import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Trophy, Sparkles } from 'lucide-react';
interface Plan {
  id: string;
  title: string;
  emoji: string;
  description: string;
  ideal: string;
  originalPrice: string;
  price: string;
  href: string;
  badge?: string;
  badgeStyle?: 'popular' | 'premium';
}
const plans: Plan[] = [{
  id: 'basic',
  title: 'Mega Pack de Recursos Docentes',
  emoji: '📚',
  description: 'Planificaciones +250 ideas + ideas + 4 Bonus exclusivos',
  ideal: 'Ideal para: Docentes que buscan recursos listos para usar',
  originalPrice: '$49.990',
  price: '$19.990',
  href: 'https://checkout.tuvidasimple.shop/cart/44331468619878:1',
  badge: 'MÁS ELEGIDO',
  badgeStyle: 'popular'
}, {
  id: 'premium',
  title: 'Pack Oro + Kit de Gestión Docente',
  emoji: '🏆',
  description: 'Mega Pack completo + Kit de Gestión',
  ideal: 'Ideal para: Docentes que quieren todo organizado al máximo',
  originalPrice: '$69.990',
  price: '$26.990',
  href: 'https://checkout.tuvidasimple.shop/cart/45587122782310:1',
  badge: 'MEJOR VALOR',
  badgeStyle: 'premium'
}];
export function PlanSelector() {
  const [selectedId, setSelectedId] = useState<string>('basic');
  const selectedPlan = plans.find(p => p.id === selectedId) || plans[0];
  return <div className="space-y-4" data-id="element-43">
      <div className="text-center mb-6" data-id="element-44">
        <h3 className="text-2xl md:text-3xl font-extrabold text-slate-900" data-id="element-45">
          Elegí tu{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-pink-500" data-id="element-46">
            MegaPack
          </span>
        </h3>
      </div>

      <div className="space-y-4" data-id="element-47">
        {plans.map(plan => {
        const isSelected = selectedId === plan.id;
        return <motion.button key={plan.id} type="button" onClick={() => setSelectedId(plan.id)} whileTap={{
          scale: 0.99
        }} className={`w-full text-left rounded-2xl p-4 sm:p-5 md:p-6 transition-all duration-300 relative ${isSelected ? 'bg-gradient-to-br from-yellow-50 to-orange-50 border-2 border-orange-400 shadow-lg shadow-orange-200/50' : 'bg-white border-2 border-slate-200 hover:border-orange-200'}`} aria-pressed={isSelected} data-id="element-48">
              {plan.badge && <div className={`absolute -top-3 right-4 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md flex items-center gap-1 ${plan.badgeStyle === 'premium' ? 'bg-gradient-to-r from-pink-500 to-purple-600' : 'bg-gradient-to-r from-yellow-400 to-orange-400'}`} data-id="element-49">
                  {plan.badgeStyle === 'premium' ? <Trophy className="w-3 h-3" data-id="element-50" /> : <Sparkles className="w-3 h-3" data-id="element-51" />}
                  {plan.badge}
                </div>}

              <div className="flex items-start gap-3 sm:gap-4" data-id="element-52">
                {/* Radio indicator */}
                <div className="flex-shrink-0 mt-1" data-id="element-53">
                  <div className={`w-5 h-5 sm:w-6 sm:h-6 rounded-full border-2 flex items-center justify-center transition-all ${isSelected ? 'border-orange-500 bg-orange-500' : 'border-slate-300 bg-white'}`} data-id="element-54">
                    {isSelected && <motion.div initial={{
                  scale: 0
                }} animate={{
                  scale: 1
                }} className="w-2 h-2 sm:w-2.5 sm:h-2.5 bg-white rounded-full" data-id="element-55" />}
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0" data-id="element-56">
                  <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 sm:gap-4" data-id="element-57">
                    <div className="flex-1 min-w-0" data-id="element-58">
                      <div className="flex items-center gap-2 mb-1" data-id="element-59">
                        {plan.badgeStyle === 'premium' ? <Trophy className="w-5 h-5 text-yellow-500 flex-shrink-0" data-id="element-60" /> : <span className="text-lg" aria-hidden="true" data-id="element-61">
                            {plan.emoji}
                          </span>}
                        <h4 className="font-extrabold text-slate-900 text-sm sm:text-base md:text-lg leading-tight uppercase tracking-tight" data-id="element-62">
                          {plan.title}
                        </h4>
                      </div>
                      <p className="text-slate-600 text-xs sm:text-sm mb-1" data-id="element-63">
                        {plan.description}
                      </p>
                      <p className="text-orange-600 font-semibold text-xs sm:text-sm" data-id="element-64">
                        {plan.ideal}
                      </p>
                    </div>

                    {/* Price */}
                    <div className="flex sm:flex-col items-baseline sm:items-end gap-2 sm:gap-0 flex-shrink-0" data-id="element-65">
                      <span className="text-slate-400 text-sm md:text-base line-through" data-id="element-66">
                        {plan.originalPrice}
                      </span>
                      <span className={`font-extrabold text-xl sm:text-2xl md:text-3xl leading-none ${isSelected ? 'text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-pink-500' : 'text-slate-700'}`} data-id="element-67">
                        {plan.price}
                      </span>
                      <span className={`text-xs font-bold ${isSelected ? 'text-orange-500' : 'text-slate-500'}`} data-id="element-68">
                        ARS
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </motion.button>;
      })}
      </div>

      {/* Dynamic CTA */}
      <motion.a key={selectedPlan.id} href={selectedPlan.href} target="_blank" rel="noopener noreferrer" initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} whileTap={{
      scale: 0.98
    }} className="block w-full bg-gradient-to-r from-yellow-400 to-orange-400 hover:from-yellow-500 hover:to-orange-500 text-white text-center font-extrabold text-sm sm:text-base md:text-lg py-4 md:py-5 px-4 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 mt-2" data-id="element-69">
        <span className="flex items-center justify-center gap-2 flex-wrap" data-id="element-70">
          <ArrowRight className="w-5 h-5 flex-shrink-0" data-id="element-71" />
          <span className="uppercase tracking-tight" data-id="element-72">
            Quiero {selectedPlan.title}
          </span>
        </span>
      </motion.a>
    </div>;
}